import { render, staticRenderFns } from "./VStatus.vue?vue&type=template&id=187f27d6&"
import script from "./VStatus.vue?vue&type=script&lang=js&"
export * from "./VStatus.vue?vue&type=script&lang=js&"
import style0 from "./VStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports